var _path, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "382px",
    height: "512px",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 55.48 74.18",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.65 0h24.82l21.01 21.92v42.61c0 5.33-4.32 9.65-9.65 9.65h-36.18c-5.33 0-9.65-4.32-9.65-9.65v-54.88c0-5.33 4.32-9.65 9.65-9.65z",
    fill: "#0263D1",
    fillRule: "nonzero"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "34.44 0 34.44 21.74 55.48 21.74",
    fill: "#fff",
    fillOpacity: 0.30196
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.96 52.93v-12.28h4.35c0.87 0 1.68 0.13 2.43 0.37 0.75 0.25 1.43 0.61 2.04 1.09s1.09 1.12 1.44 1.92 0.53 1.72 0.53 2.76-0.18 1.96-0.53 2.76-0.83 1.44-1.44 1.92-1.29 0.84-2.04 1.09c-0.75 0.24-1.56 0.37-2.43 0.37h-4.35zm3.07-2.67h0.91c0.49 0 0.95-0.06 1.36-0.17 0.42-0.12 0.8-0.31 1.16-0.56s0.64-0.61 0.84-1.08c0.21-0.46 0.31-1.02 0.31-1.66s-0.1-1.2-0.31-1.67c-0.2-0.46-0.48-0.82-0.84-1.07-0.36-0.26-0.74-0.44-1.16-0.56-0.41-0.11-0.87-0.17-1.36-0.17h-0.91v6.94zm15.17 2.81c-1.85 0-3.38-0.6-4.59-1.79s-1.81-2.69-1.81-4.49 0.6-3.3 1.81-4.49 2.74-1.79 4.59-1.79c1.82 0 3.33 0.6 4.54 1.79 1.2 1.19 1.8 2.69 1.8 4.49s-0.6 3.3-1.8 4.49c-1.21 1.19-2.72 1.79-4.54 1.79zm-2.36-3.69c0.61 0.68 1.39 1.02 2.34 1.02s1.72-0.34 2.33-1.02c0.61-0.69 0.91-1.55 0.91-2.59s-0.3-1.9-0.91-2.59c-0.61-0.68-1.38-1.02-2.33-1.02s-1.73 0.34-2.34 1.02c-0.61 0.69-0.92 1.55-0.92 2.59s0.31 1.9 0.92 2.59zm16 3.69c-1.79 0-3.28-0.56-4.46-1.66-1.19-1.11-1.78-2.65-1.78-4.62 0-1.96 0.6-3.5 1.8-4.61 1.21-1.11 2.68-1.67 4.44-1.67 1.59 0 2.89 0.39 3.92 1.18 1.02 0.78 1.61 1.82 1.76 3.12l-3.1 0.63c-0.13-0.68-0.44-1.23-0.92-1.64s-1.04-0.62-1.68-0.62c-0.88 0-1.61 0.31-2.2 0.94-0.59 0.64-0.89 1.52-0.89 2.67s0.3 2.03 0.88 2.66c0.59 0.64 1.32 0.95 2.21 0.95 0.64 0 1.19-0.18 1.64-0.54s0.73-0.84 0.85-1.44l3.17 0.72c-0.29 1.24-0.93 2.2-1.93 2.89-0.99 0.69-2.23 1.04-3.71 1.04z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.2220eb77a486e74f3bab63ad27761897.svg";
export { ForwardRef as ReactComponent };